import axios from 'axios';

const PRE_SO_JOBS_PATH = '/api/pre-so-jobs';

class PreSOJobService {
  async fetchPreSOJobsCount(params) {
    const url = `${PRE_SO_JOBS_PATH}/count`;
    const result = await axios.get(url, {
      params: params
    });
    return result;
  }
  async fetchPreSOJobs(params) {
    const url = `${PRE_SO_JOBS_PATH}`;
    const result = await axios.get(url, {
      params: params
    });
    return result;
  }

  async fetchUnitPreSOJobs(unitId) {
    const url = `${PRE_SO_JOBS_PATH}/${unitId}`;
    const result = await axios.get(url);
    return result;
  }

  async addPreSOJobsToSO(jobs) {
    const url = `${PRE_SO_JOBS_PATH}`;
    const result = await axios.post(url, jobs);
    return result;
  }

  async updatePreSOJobVin(jobId, vinData) {
    const url = `${PRE_SO_JOBS_PATH}/${jobId}`;
    const result = await axios.put(url, vinData);
    return result;
  }
}
export default new PreSOJobService(); // singleton object
